<template lang="pug">
#gestao-relatorio-rastreabilidade
    BaseHeader#nova-analise-relatorio-rastreabilidade(
        :titulo='$t("mensagens.relatorioRastreabilidade.listagem.titulo")',
        icon='el-icon-circle-plus-outline',
        :btnTexto='$t("mensagens.relatorioRastreabilidade.listagem.botaoHeader")',
        :exibeBotao='true',
        @btnHeaderClicado='novoRelatorio'
    )

    .view-container.margen-bottom-pages
        .bloco-pesquisa-filtros
            BlocoPesquisaFiltros(
                @filtro='filtro',
                :carregando='carregandoRelatorios'
            )

        .secao-listagem
            .titulo-listagem
                h3 {{ $t('mensagens.relatorioRastreabilidade.listagem.tituloListagem') }}

        .bloco-novos-relatorios-tabela
            TabelaGestaoRelatorioRastreabilidade(
                :relatorios='relatorios',
                :paginacao='paginacao',
                :carregando='carregandoRelatorios',
                @mudarPagina='mudarPagina',
                @handleSort='handleSort',
                @removerContratoRelatorio='removerContratoRelatorio',
                @carregarTabela='carregarTabela'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import TabelaGestaoRelatorioRastreabilidade from '@/components/relatorioRastreabilidade/TabelaGestaoRelatorioRastreabilidade.vue';
import BlocoPesquisaFiltros from '@/components/relatorioRastreabilidade/PesquisaFiltroRelatorioRastreabilidade.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';

export default {
    name: 'GestaoRelatorioRastreabilidade',
    components: {
        BaseHeader,
        TabelaGestaoRelatorioRastreabilidade,
        BlocoPesquisaFiltros
    },
    data() {
        return {
            paginacao: {
                total: 0,
                pagina: 0,
                itensPorPagina: 10,
                ordenacao: 'data_analise,desc'
            },
            relatorios: [],
            carregandoRelatorios: false,
            numeroContrato: ''
        };
    },
    mounted() {
        this.numeroContrato = '';
        this.buscarRelatorios(0);
    },
    watch: {
        '$i18n._vm.locale': function () {
            this.buscarRelatorios(0);
        }
    },
    methods: {
        novoRelatorio() {
            this.$router.push({ name: 'CadastrarRelatorio' });
        },
        async buscarRelatorios(pagina) {
            this.paginacao.pagina = pagina;
            this.carregandoRelatorios = true;
            try {
                const result =
                    await RelatorioRastreabilidadeService.buscarRelatorios(
                        this.paginacao,
                        this.numeroContrato
                    );
                this.relatorios = result.data.itens;
                this.paginacao = {
                    ordenacao: this.paginacao.ordenacao,
                    ...result.data.paginacao
                };
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.listagem.erroBuscarRelatorios'
                    )
                });
            }
            this.carregandoRelatorios = false;
        },
        mudarPagina(novaPagina) {
            this.buscarRelatorios(novaPagina);
        },
        filtro(pesquisa) {
            this.numeroContrato = pesquisa;
            this.buscarRelatorios(0);
        },
        handleSort(params) {
            this.paginacao.ordenacao = `${params.column},${params.order}`;
            this.buscarRelatorios(0);
        },
        carregarTabela() {
            this.buscarRelatorios(0);
        },
        async removerContratoRelatorio(idContratoRelatorio) {
            try {
                const response =
                    await RelatorioRastreabilidadeService.deletarRelatorios(
                        idContratoRelatorio
                    );
                if (response.status === 200) {
                    this.buscarRelatorios(0);
                    this.$notify.success({
                        message: response.data
                    });
                } else {
                    this.$notify.error({
                        message: response.data
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.listagem.erroRemoverRelatorio'
                    )
                });
            }
        }
    }
};
</script>

<style lang="scss">
#gestao-relatorio-rastreabilidade {
    .secao-listagem {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;

        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .secao-listagem {
        margin-top: 20px;
    }
}
</style>
